import type React from 'react';
import { useCallback } from 'react';

import { PlaybookCard } from '../../playbook-card/playbook-card';

import { usePlaybooks } from '../use-playbooks';
import { useOpenRuleEditor } from '../use-open-rule-editor';
import { messages } from '../messages';

export const ResidentialRuleCard: React.FC = () => {
  const openRuleEditor = useOpenRuleEditor();
  const { residentialRule } = usePlaybooks();
  const handleClick = useCallback(() => openRuleEditor(residentialRule), [openRuleEditor, residentialRule]);

  return (
    <PlaybookCard
      description={messages.residentialShippingDescription}
      glyph='residentialScene'
      onClick={handleClick}
      title={messages.residentialShippingTitle}
    />
  );
};
